const React = require('react');
const PropTypesLib = require('prop-types');
const mobxReactLite = require('mobx-react-lite');

const MobXProviderContext = React.createContext({});

function Provider(props) {
  const { children, ...stores } = props;
  const parentStores = React.useContext(MobXProviderContext);
  const value = { ...parentStores, ...stores };
  return React.createElement(MobXProviderContext.Provider, { value }, children);
}

function inject(storeNames) {
  return function wrapComponent(WrappedComponent) {
    const Injector = React.forwardRef((props, ref) => {
      const availableStores = React.useContext(MobXProviderContext);
      const injectedProps = Array.isArray(storeNames)
        ? storeNames.reduce((accumulator, storeName) => {
            accumulator[storeName] = availableStores[storeName];
            return accumulator;
          }, {})
        : typeof storeNames === 'function'
          ? storeNames(availableStores, props)
          : {};

      return React.createElement(WrappedComponent, {
        ...props,
        ...injectedProps,
        ref,
      });
    });

    Injector.displayName = `inject-${WrappedComponent.displayName || WrappedComponent.name || 'Component'}`;
    return Injector;
  };
}

function observer(Component) {
  const isClassComponent =
    typeof Component === 'function' &&
    Component.prototype &&
    (Component.prototype.isReactComponent || Component.prototype.render);

  if (isClassComponent) {
    const originalRender = Component.prototype.render;
    Component.prototype.render = function observerRender() {
      return React.createElement(
        mobxReactLite.Observer,
        null,
        () => originalRender.call(this)
      );
    };
    return Component;
  }

  return mobxReactLite.observer(Component);
}

const MobxPropTypes = {
  observableArray: PropTypesLib.array,
  observableArrayOf: PropTypesLib.arrayOf,
  observableMap: PropTypesLib.object,
  observableObject: PropTypesLib.object,
  arrayOrObservableArray: PropTypesLib.array,
  arrayOrObservableArrayOf: PropTypesLib.arrayOf,
  objectOrObservableObject: PropTypesLib.object,
};

module.exports = {
  MobXProviderContext,
  Observer: mobxReactLite.Observer,
  PropTypes: MobxPropTypes,
  Provider,
  disposeOnUnmount: function disposeOnUnmount() {
    return undefined;
  },
  enableStaticRendering: mobxReactLite.enableStaticRendering,
  inject,
  isUsingStaticRendering: mobxReactLite.isUsingStaticRendering,
  observer,
  observerBatching: mobxReactLite.observerBatching,
  useAsObservableSource: mobxReactLite.useAsObservableSource,
  useLocalObservable: mobxReactLite.useLocalObservable,
  useLocalStore: mobxReactLite.useLocalStore,
  useObserver: mobxReactLite.useObserver,
  useStaticRendering: mobxReactLite.enableStaticRendering,
};
